import { Stack } from "@material-ui/core";
import { Box } from "@material-ui/system";
import { WalletEarnReward } from "src/components/WalletEarnReward";
import { WalletIntro } from "src/components/WalletIntro";
import { WalletSupportTokens } from "src/components/WalletSupportTokens";
import { WalletValidatorMarket } from "src/components/WalletValidatorMarket";

export const Wallet = () => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box width="1280px">
        <WalletIntro />
      </Box>

      <Stack
        id="supportTokens"
        alignSelf="stretch"
        alignItems="center"
        sx={{
          backgroundColor: "#1D232A",
        }}
      >
        <Box width="1280px">
          <WalletSupportTokens />
        </Box>
      </Stack>

      <Box width="1280px">
        <WalletEarnReward />
      </Box>

      <Stack
        alignSelf="stretch"
        alignItems="center"
        sx={{
          backgroundColor: "#1D232A",
        }}
      >
        <Box width="1280px">
          <WalletValidatorMarket />
        </Box>
      </Stack>
    </Box>
  );
};
